import React, { useEffect, useState, useMemo } from 'react'
import { connect } from 'react-redux';
import GetBrandListOAmazonProductService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/GetBrandListOAmazonProductService';
import { Button, Card, Col, Row, Input, Label } from 'reactstrap';
import GetFileListByCategoryService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/GetFileListByCategoryService';
import BackButton from "../../../../.././../../../../designUtils/Logo/BackButton.svg"
import UploadAllTypeOfAssetsFile from './Components/UploadAllTypeOfAssetsFile';
import LoadingOverlay from 'react-loading-overlay';
import Loader from "react-loaders";
import ImageAndLogo from './Components/Brand/ImageAndLogo';
import ProductImageAndLogo from './Components/Product/ProductImageAndLogo';
import GetFileListBySubCategoryService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/GetFileListBySubCategoryService';
import FetchAllCategoryAndSubCategoryService from '../../../../../../../../../Service/DashboardServices/AssetGalleryServices/FetchAllCategoryAndSubCategoryService';
import OtherProductAssets from './Components/Product/OtherProductAssets';
import UploadImagesAndOriginalFiles from './Components/UploadImagesAndOriginalFiles'
import AmazonProductLiveImages from './Components/Product/AmazonProductLiveImages';
import UploadVideosPage from './Components/Brand/UploadVideosPage';
import VideosForBrand from './Components/Brand/VideosForBrand';
import ProductCatalogueDetailsFile from './Components/Product/ProductCatalogueDetailsFile';
import AssetsProductList from './Components/Product/AssetsProductList';
import CreateBrandProfileMainPage from '../../Questionnaire/CreateBrandProfileMainPage';
import GetBrandProfileListService from '../../../../../../../../../Service/DashboardServices/QuestionnaireServices/GetBrandProfileListService';
/*
*levelId 1 product information
* levelId 2 media 
* level 3  documents 
*/
function ProductDetails(props) {
  const [amazonProductBrandList, setAmazonProductBrandList] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [fileListOfAssets, setFileListOfAssets] = useState(false);
  const [ASIN, setAsin] = useState();
  const [titleProduct, setTitleProduct] = useState()
  const [ASINImage, setAsinImage] = useState();
  const [isProductSubtabs, setIsProductSubtabs] = useState(false);
  const [subCategoryId, setSubCategoryId] = useState(7)
  const [uploadImagesPage, setUploadImagesPage] = useState(false)
  const [loadScreen, setLoadScreen] = useState(false)
  const [allFileListOfAssets, setAllFileListOfAssets] = useState([]);
  const [subCategoryText, setSubCategoryText] = useState('')
  const [groupedSubCategories, setGroupedSubCategories] = useState({});
  const [activeTab, setActiveTab] = useState(1);
  const [fileListOfAssetsVideo, setFileListOfAssetsVideo] = useState();
  const [productName, setProductName] = useState('')
  const [isInfoTabOpen, setIsInfoTabOpen] = useState(false)
  const [subCategoryMainText, setSubCategoryMainText] = useState(false)
  const [levelWiseGruping, setLevelWiseGruping] = useState(1)
  const [groupOfSubCat, setGroupOfSubCat] = useState({})
  const [productImgFlag,setProductImgFlag]=useState(true)
  const [selectedAssets, setSelectedAssets] = useState([]);


  const [brand, setBrand] = useState({
    id: 'New',
    brandName: ''
  });
  const [levelId,setLevelId]=useState(1)

  const setProductDetails = (product) => {
    console.log(product);
    if(product.itemImage=='' || product.itemImage==null){
      setProductImgFlag(false)
    }
    else{
      setProductImgFlag(true)
    }
    const submainTypes = product.statsPropertiesList && product.statsPropertiesList.filter((subCat) => (subCat.assetSubCategory_id == 0))
    setSubCategoryMainText({...submainTypes})
    const groupedByLevelId = product.statsPropertiesList && product.statsPropertiesList.reduce((acc, item) => {
      const { levelId, assetSubCategory_id } = item;

      // Skip items where assetSubCategory_id is 0
      if (assetSubCategory_id === 0) {
        return acc;
      }

      if (!acc[levelId]) {
        acc[levelId] = [];
      }

      acc[levelId].push(item);
      return acc;
    }, {});



    setGroupOfSubCat({ ...groupedByLevelId[1] });
    setLevelId(1)

    setLevelWiseGruping(groupedByLevelId)
    setIsProductSubtabs(true)
    setAsin(product.asin)
    setTitleProduct(product.productTitle)
    setProductName(product.productTitle)
    setAsinImage(product.itemImage)
    setIsInfoTabOpen(false);
    GetFileListBySubCategory(subCategoryId, product.asin)
    let data = {
      integerId: props.storeOverview.integerID,
      assetIdentifier:product.asin?product.asin:''
    };
    GetBrandListOAmazonProductService(props.token, data).then((response) => {
      if (response) {
        setAmazonProductBrandList(response.productList);
        console.log('response');
        console.log(response);
      }
    });
  }
  const handleBackbutton = () => {
    setIsProductSubtabs(false)
    setActiveTab(1)
    setSubCategoryId(7)
    setSelectedAssets([]); // Clear selection on back
  }
  const handleUploadAssetsUi = () => {
    setUploadImagesPage(true)
    setIsInfoTabOpen(false);
  }
  const handleMainTabs = (subMain) => {
    setLevelId(subMain.levelId)
    setActiveTab(subMain.levelId)
    setSelectedAssets([]); // Clear selection when changing main tabs

    const group = levelWiseGruping[subMain.levelId];
    console.log(subMain)
    console.log(group)
    

    if (group) {
      setGroupOfSubCat({...group});
      // levelId==1 -- for Product Information
      if(subMain.levelId==1){

        GetFileListBySubCategory(7,ASIN)
        setSubCategoryId(7);
      }
      else if(subMain.levelId==2){
        GetFileListBySubCategory(9,ASIN)

        setSubCategoryId(9);
      }
      else if (subMain.levelId==3){
        setSubCategoryId(15);
        GetFileListBySubCategory(15,ASIN)
      }
      else{}
      console.log(group);
    } else {
      console.warn(`No group found for levelId: ${subMain.levelId}`);
      setGroupOfSubCat([]); // Optional: clear if no match
    }

  }
  const handleProductSubCategory = (tab) => {
    console.log(tab)
    setSubCategoryId(tab.assetSubCategory_id);
    setSubCategoryText(tab.displayText)
    setIsInfoTabOpen(false);
    setSelectedAssets([]); // Clear selection when changing sub-tabs
  }
  const GetFileListBySubCategory = (id, asin) => {
    setLoadScreen(true)
    let data = {
      integerId: props.storeOverview.integerID,
      assetCategory: props.catId,
      subCategoryId: id ? id : '',
      assetIdentifier: asin ? asin : ''
    };
    GetFileListBySubCategoryService(props.token, data).then((response) => {
      if (response) {
        const imageFiles = response.fileList.filter(file => {
          const extension = file.fileName.toLowerCase().split('.').pop();
          return ['jpg', 'png', 'jpeg'].includes(extension);
        });
        const videoFiles = response.fileList.filter(file => {
          const extension = file.fileName.toLowerCase().split('.').pop();
          return ['mp4', 'mov', 'avi', 'mkv'].includes(extension);
        });
        setFileListOfAssetsVideo(videoFiles)
        console.log(response)
        setFileListOfAssets(imageFiles);
        setAllFileListOfAssets(response.fileList)
        setLoadScreen(false)
      }
    });
  }
  const closeQuestionnaire = () => {
    let data = {
      integerId: props.storeOverview.integerID
    }
    GetBrandProfileListService(props.token, data).then((response) => {
      if (response) {
        // setBrandProfile(response.brandList);
        // setShowCreateBrandProfile(true)
      }
    });

  }
  const handleBackFromUploadAssets = () => {
    setUploadImagesPage(false)

  }
  const handleOpenFileInfo = () => {
    setIsInfoTabOpen(!isInfoTabOpen)
  }
  const renderUploadAssetsPage = () => {

    //subCategoryId =6 Media - Live amazon images 7=>Media - Product photos 8=>Media - Lifestyle photos 11=>Media - Packaging images 12=>Media - Other images

    if (subCategoryId == 6 || subCategoryId == 7 || subCategoryId == 8 || subCategoryId == 11 || subCategoryId == 12) {
      return (
        <UploadImagesAndOriginalFiles
          setGroupOfSubCat={setGroupOfSubCat}
          setLevelId={setLevelId}
          action={true}
          setSubCategoryMainText={setSubCategoryMainText}
          subCategoryMainText={subCategoryMainText}
          levelId={levelId}
          groupOfSubCat={groupOfSubCat}
          subCategoryId={subCategoryId}
          handleBackFromUploadAssetsImages={handleBackFromUploadAssetsImages}
          assetIdentifier={ASIN}
          setFileListOfAssets={setFileListOfAssets}
          assetCategory={props.catId} />
      )
    }
    else if (subCategoryId == 14) {
      return (
        <UploadVideosPage
          setGroupOfSubCat={setGroupOfSubCat}
          setLevelId={setLevelId}
          action={true}
          setSubCategoryMainText={setSubCategoryMainText}
          subCategoryMainText={subCategoryMainText}
          levelId={levelId}
          groupOfSubCat={groupOfSubCat}
          subCategoryId={subCategoryId}
          handleBackFromUploadAssetsImages={handleBackFromUploadAssetsImages}
          assetIdentifier={ASIN}
          fileListOfAssetsVideo={fileListOfAssetsVideo}
          setFileListOfAssetsVideo={setFileListOfAssetsVideo}
          setFileListOfAssets={setFileListOfAssets}
          assetCategory={props.catId}
        />
      )
    }

    else {
      return (
        <UploadAllTypeOfAssetsFile
          setGroupOfSubCat={setGroupOfSubCat}
          setLevelId={setLevelId}
          action={true}
          setSubCategoryMainText={setSubCategoryMainText}
          subCategoryMainText={subCategoryMainText}
          levelId={levelId}
          groupOfSubCat={groupOfSubCat}
          subCategoryId={subCategoryId}
          handleBackFromUploadAssets={handleBackFromUploadAssets}
          setFileListOfAssets={setFileListOfAssets}
          setAllFileListOfAssets={setAllFileListOfAssets}
          flagNumber={10}
          assetIdentifier={ASIN}
          assetCategory={props.catId} />
      )
    }
  }
  const handleBackFromUploadAssetsImages = () => {
    setUploadImagesPage(false)
  }
  const filteredProductList =
  amazonProductBrandList &&
  amazonProductBrandList.filter((row) => {
    const asin = row.asin.toLowerCase();
    const productTitle = row.productTitle.toLowerCase();

    if (row.skus != null) {
      const skus = row.skus.join("").toLowerCase();
      if (searchTerm !== "") {
        return (
          asin.includes(searchTerm.toLowerCase()) ||
          productTitle.includes(searchTerm.toLowerCase()) ||
          skus.includes(searchTerm.toLowerCase())
        );
      }
    }
    if (searchTerm !== "") {
      return (
        asin.includes(searchTerm.toLowerCase()) ||
        productTitle.includes(searchTerm.toLowerCase())
      );
    }
    else {
      return true
    }

  });
  
//--- SELECTION AND DOWNLOAD LOGIC ---

/* SubCategory Id's 
("Media - Product Photos"=7)
("Media - Lifestyle Photos"=8)
("Media - Packaging Images"=11)
("Media - Other Images"=12)
("Media - Videos"=14)
("Product Information - Questionnaire"=15)
("Product Information - Catalogue Details"=16)
*/

// 1. Get the list of assets currently being displayed
const currentAssetList = useMemo(() => {
  if (subCategoryId === 7 || subCategoryId === 8 || subCategoryId === 11 || subCategoryId === 12) {
    return fileListOfAssets || [];
  }
  if (subCategoryId === 14) {
    return fileListOfAssetsVideo || [];
  }
  // For 'Other' assets, assuming it uses allFileListOfAssets
  if (subCategoryId !== 15 && subCategoryId !== 16) {
    return allFileListOfAssets || [];
  }
  return []; 
}, [subCategoryId, fileListOfAssets, fileListOfAssetsVideo, allFileListOfAssets]);

// 2. Handler to select/deselect a single asset
const handleSelectAsset = (fileName) => {
  setSelectedAssets(prevSelected => {
    if (prevSelected.includes(fileName)) {
      return prevSelected.filter(name => name !== fileName); // Deselect
    } else {
      return [...prevSelected, fileName]; // Select
    }
  });
};

// 3. Handler for the "Select All" checkbox
const handleSelectAll = (e) => {
  if (e.target.checked) {
    // Select all
    const allFileNames = currentAssetList.map(asset => asset.fileName);
    setSelectedAssets(allFileNames);
  } else {
    // Deselect all
    setSelectedAssets([]);
  }
};

// 4. Handler for the "Download" button
const handleDownload = () => {
  console.log("Downloading selected assets:", selectedAssets);

  // Find the full asset objects (with URLs) that are selected
  const assetsToDownload = currentAssetList.filter(asset => selectedAssets.includes(asset.fileName));

  assetsToDownload.forEach(asset => {
    const url = asset.filePath || asset.fileUrl; 
    const name = asset.actualFileName || asset.fileName;

    if (asset && url) {
      fetch(url, {
        method: 'GET',
        referrerPolicy: 'no-referrer',
        cache: 'no-store'
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Network response was not ok for ${name}`);
          }
          return response.blob();
        })
        .then(blob => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        })
        .catch(err => console.error("Download failed for:", name, err));
    } else {
      console.warn("Could not download asset, missing URL:", asset);
    }
  });
};
  // 5. Determine if the asset controls (select all, download) should be shown
  const showAssetControls = currentAssetList.length > 0 && 
                            (levelId === 1 || levelId === 2) && 
                            subCategoryId !== 20 &&  // <-- Hide for A+
                            subCategoryId !== 21 &&  // <-- Hide for Gallery
                            subCategoryId !== 6 &&    // <-- Hide for Amazon live images
                            subCategoryId !== 9 &&  // <-- Hide for Documents - Safety Data Sheets
                            subCategoryId !== 10 ;   // <-- Hide for Documents - Ingredient List
  const isAllSelected = currentAssetList.length > 0 && selectedAssets.length === currentAssetList.length;

  return (
    <>
      {uploadImagesPage ? renderUploadAssetsPage() :
        <>
          {!isProductSubtabs ?
            <AssetsProductList
              setProductDetails={setProductDetails}
            />
            :
            <Col md={12}>
              <Card className='p-2 mb-3 child-card' >
                <Row>
                  <Col md={12}>
                    <div className='d-flex justify-content-between'>
                      <div className='d-flex'>
                        <button
                          onClick={() => { handleBackbutton() }}
                          className="hover-btn-link back-btn ml-2 mb-3 mr-1 "  >
                          <img src={BackButton} alt="not found" />
                        </button>
                        <h5 className='product-name' title={productName}><b>{ASIN} : {productName}</b></h5>
                      </div>
                      {
                        (levelId !== 3 && subCategoryId != 6) ?
                          <>
                            {props.UserPermission.AssetGallery_UploadProductAssets &&

                              <Button
                                onClick={() => handleUploadAssetsUi()}
                                className='btn-background-color-Proceed-gallery  ml-2'
                              // disabled={!brand}
                              >
                                Upload Assets

                              </Button>}
                          </> : ''
                      }
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="d-flex">
                      {Object.values(subCategoryMainText).map((subMain) => (
                        <p
                          className={` assets-category-tab ml-3 ${activeTab === subMain.levelId ? "selected-tab-assets-tab" : "assets-tab-not-selected"
                            }`}
                          onClick={() => handleMainTabs(subMain)}
                        >
                          <b>{subMain.displayText}</b>
                          {subMain.levelId !=3 && subMain.asset_count!=0 ?
                          <span className="assets-category-count">
                            {subMain.asset_count}</span>:''
                              }
                              
                        </p>
                      ))}

                    </div>
                    <div className='d-flex mt-1 border-assets-subtypes'>
                      {Object.values(groupOfSubCat).map((item, index)  =>
                      (<>

                        <p className={`mb-0 d-flex ${item.assetSubCategory_id === subCategoryId ? 'selected-tab-assets-subtab' : 'not-selected-tab-assets-subtab'}`}
                          onClick={() => { handleProductSubCategory(item); GetFileListBySubCategory(item.assetSubCategory_id, ASIN); }}
                        >
                          {item.displayText}
                          <span>
                          {item.assetSubCategory_id !=15 && item.assetSubCategory_id !=16 && item.assetSubCategory_id!=6 && item.asset_count!=0  ?
                            <span className="assets-category-count">
                              {item.asset_count}
                            </span>:''

                            }
                          {
                          item.assetSubCategory_id === 6 && productImgFlag === true ? (
                            <span className="assets-category-count">
                              1
                            </span>
                          ) : null
                        }
                                </span>
                          </p>
                      </>)
                      )
                      }
                    </div>
                  </Col>
                </Row>
              </Card>


              {showAssetControls && (
                  <Row className='d-flex align-items-center mb-1'>
                    <Col md={6}>
                      <div className='d-flex align-items-center'>
                        <Input
                          type='checkbox'
                          id='selectAllCheckbox'
                          className='ml-1'
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                        />
                        <span for='selectAllCheckbox' className='mb-0 ml-4' style={{cursor: 'pointer'}}>
                          Select All ({selectedAssets.length} / {currentAssetList.length})
                        </span>
                      </div>
                    </Col>
                    <Col md={6} className='d-flex justify-content-end'>
                      <Button
                        color='primary'
                        className='btn-background-color-Proceed-gallery'
                        disabled={selectedAssets.length === 0}
                        onClick={handleDownload}
                      >
                        Download 
                      </Button>
                    </Col>
                  </Row>
              )}

              <Col md={12} className='pl-0 pr-0'>
                <LoadingOverlay
                  active={loadScreen}
                  styles={{
                    overlay: (base) => ({
                      ...base,
                      background: '#f1f4f6',
                      opacity: 1,
                    }),
                    content: (base) => ({
                      ...base,
                      color: '#000',
                    }),
                  }}
                  spinner={<Loader active type="ball-pulse" />}
                  text="Loading asset details..."
                >
                  {subCategoryId == 15 ? //brand profile
                    <CreateBrandProfileMainPage
                      closeQuestionnaire={closeQuestionnaire}
                      brand={brand}
                      asin={ASIN}
                      titleProduct={titleProduct}
                      categoryID={2} /> :
                    subCategoryId === 6 ?//subCategoryId =6 Media - Live amazon images 
                      <AmazonProductLiveImages
                       subCategoryId={subCategoryId}
                       handleBackFromUploadAssetsImages={handleBackFromUploadAssetsImages}
                       assetIdentifier={ASIN}
                       setFileListOfAssets={setFileListOfAssets}
                       titleProduct={titleProduct}
                       assetCategory = {props.catId}
                       filteredProductList={filteredProductList}
                       ASINImage={ASINImage}
                       selectedAssets={selectedAssets}
                       onSelectAsset={handleSelectAsset}
                      />
                      //subCategoryId  7=>Media - Product photos 8=>Media - Lifestyle photos 11=>Media - Packaging images 12=>Media - Other images
                      : subCategoryId === 7 || subCategoryId === 8 || subCategoryId === 11 || subCategoryId === 12 ?
                        <ProductImageAndLogo
                          action={true}
                          setGroupOfSubCat={setGroupOfSubCat}
                          setLevelId={setLevelId}
                          setSubCategoryMainText={setSubCategoryMainText}
                          subCategoryMainText={subCategoryMainText}
                          levelId={levelId}
                          groupOfSubCat={groupOfSubCat}
                          // changeTabs={changeTabs}
                          subCategoryId={subCategoryId}
                          fileListOfAssets={fileListOfAssets}
                          assetIdentifier={ASIN}
                          assetCategory={props.catId}
                          handleOpenFileInfo={handleOpenFileInfo}
                          isInfoTabOpen={isInfoTabOpen}
                          setIsInfoTabOpen={setIsInfoTabOpen}
                          setFileListOfAssets={setFileListOfAssets}
                          setAllFileListOfAssets={setAllFileListOfAssets}
                          allFileListOfAssets={allFileListOfAssets}
                          selectedAssets={selectedAssets}
                          onSelectAsset={handleSelectAsset}
                        />

                        : subCategoryId === 14 ? //videos
                          <VideosForBrand
                            setGroupOfSubCat={setGroupOfSubCat}
                            action={true}
                            setLevelId={setLevelId}
                            setSubCategoryMainText={setSubCategoryMainText}
                            subCategoryMainText={subCategoryMainText}
                            levelId={levelId}
                            groupOfSubCat={groupOfSubCat}
                            subCategoryId={subCategoryId}
                            handleBackFromUploadAssetsImages={handleBackFromUploadAssetsImages}
                            assetIdentifier={ASIN}
                            handleOpenFileInfo={handleOpenFileInfo}
                            fileListOfAssetsVideo={fileListOfAssetsVideo}
                            setIsInfoTabOpen={setIsInfoTabOpen}
                            isInfoTabOpen={isInfoTabOpen}
                            setFileListOfAssetsVideo={setFileListOfAssetsVideo}
                            setFileListOfAssets={setFileListOfAssets}
                            assetCategory={props.catId}

                            selectedAssets={selectedAssets}
                            onSelectAsset={handleSelectAsset}
                          /> : subCategoryId === 16 ? // catelog details
                            <ProductCatalogueDetailsFile
                              ASIN={ASIN}
                              integerID={props.storeOverview.integerID}
                            />
                            :

                            <OtherProductAssets // others
                              setGroupOfSubCat={setGroupOfSubCat}
                              action={true}
                              setLevelId={setLevelId}
                              setSubCategoryMainText={setSubCategoryMainText}
                              subCategoryMainText={subCategoryMainText}
                              levelId={levelId}
                              groupOfSubCat={groupOfSubCat}
                              assetCategory={props.catId}
                              assetIdentifier={ASIN}
                              subCategoryId={subCategoryId}
                              fileListOfAssets={fileListOfAssets}
                              setFileListOfAssets={setFileListOfAssets}
                              allFileListOfAssets={allFileListOfAssets}
                              setAllFileListOfAssets={setAllFileListOfAssets}
                              selectedAssets={selectedAssets}
                              onSelectAsset={handleSelectAsset}
                            />}
                </LoadingOverlay>
              </Col>
            </Col>

          }
        </>
      }
    </>

  )
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    storeOverview: state.accountOverview.store.storeOverview,
    childProducts: state.accountOverview.store.childProducts,
    adProfiles: state.accountOverview.landing.adProfiles,
    parentProducts: state.accountOverview.store.parentProducts,
    orphanProducts: state.accountOverview.store.orphanProducts,
    UserPermission: state.accountOverview.store.StoreUserPermission,
  };
};

export default connect(mapStateToProps)(ProductDetails);